import type { LocaleDictionary } from "@/apps/@components/locale-context";

/** 桌布活動頁的多語系文案字典。 */
export const wallpaperMessages: LocaleDictionary = {
	"zh-TW": {
		"home.title": "製作專屬您的手機桌布",
		"home.btn": "開始設計",
		"start.title": "選擇設計",
		"start.btn": "下一步",
		"text.title": "加入姓名縮寫\n自訂字體與顏色",
		"text.inputLabel": "輸入英文字母:",
		"text.fontLabel": "字型:",
		"text.font.classic": "經典",
		"text.font.handwrite": "手寫體",
		"text.colorLabel": "顏色:",
		"text.color.black": "黑色",
		"text.color.white": "白色",
		"text.btn.prev": "上一步",
		"text.btn.next": "下一步",
		"share.title": "分享好友",
    "share.description": "邀請好友定制專屬 Bunny Knot 手機桌布！",
		"share.btn": "分享好友",
		"share.copied": "已複製分享文字，快貼給好友吧！",
		"done.title": "您的專屬手機桌布已完成！",
		"done.btn.download": "點擊下載",
		"done.btn.next": "下一步",
		"done.error": "圖片產生失敗，請稍後再試",
		"done.longPressHint": "長按圖片即可儲存至手機",
		"done.close": "關閉",
	},
	en: {
		"home.title": "CREATE YOUR\nOWN WALLPAPER",
		"home.btn": "START YOUR DESIGN",
		"start.title": "SELECT YOUR DESIGN",
		"start.btn": "NEXT",
		"text.title": "ADD YOUR INTIALS",
    "text.title.en": "Customize the font and color",
		"text.inputLabel": "ENTER YOUR INITIALS:",
		"text.fontLabel": "FONT:",
		"text.font.classic": "CLASSIC",
		"text.font.handwrite": "SCRIPT",
		"text.colorLabel": "COLOR:",
		"text.color.black": "BLACK",
		"text.color.white": "WHITE",
		"text.btn.prev": "BACK",
		"text.btn.next": "NEXT",
    "share.title": "SHARE WITH FRIENDS",
    "share.description": "Invite others to create their own Bunny Knot wallpaper",
    "share.btn": "SHARE",
		"share.copied": "Share text copied — paste it to your friends!",
		"done.title": "YOUR WALLPAPER IS COMPLETE",
		"done.btn.download": "DOWNLOAD",
		"done.btn.next": "NEXT",
		"done.error": "Failed to generate image, please try again later",
		"done.longPressHint": "Press and hold the image to save it",
		"done.close": "Close",
	},
};

export default wallpaperMessages;
